import React, { FC } from 'react';

import { Icon, Typography } from '@rbilabs/universal-components';

import { t } from 'state/intl/translations';
import { getDesignToken } from 'styles/constants';

import { TextWithArrowButtonRoot } from './styled';
import { TextWithArrowButtonProps } from './types';

export const TextWithArrowButton: FC<React.PropsWithChildren<TextWithArrowButtonProps>> = ({
  onPress,
  messageId,
  withBorder = false,
}) => {
  return (
    <TextWithArrowButtonRoot
      href="#"
      onPress={event => {
        event?.preventDefault();
        onPress?.();
      }}
      withBorder={withBorder}
      accessibilityRole="link"
    >
      <Typography variant="headerThree" mb="$0_5">
        {t(messageId as any)}
      </Typography>
      <Icon variant="next" height="$4" color={getDesignToken('text-default')} />
    </TextWithArrowButtonRoot>
  );
};
